import FreeFallScreenSS_3D from './Free-Fall-screen-SS-3D.png';
import FreeFallScreenSS_2D from './Free-Fall-screen-SS-2D.png';
import FreeFallScreenSS_3D2 from './Free-Fall-screen-SS-3D_2.png';
import FreeFallScreenSS_2D2 from './Free-Fall-screen-SS-2D_2.png';
import type { UnitInfoFreeFallScreenSSInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export const getImageFreeFallScreenSS = (decks: number) => {
  if (decks === 3) {
    return FreeFallScreenSS_3D;
  } else {
    return FreeFallScreenSS_2D;
  }
};

export const getImageFreeFallScreenSS2 = (decks: number) => {
  if (decks === 3) {
    return FreeFallScreenSS_3D2;
  } else {
    return FreeFallScreenSS_2D2;
  }
};

export const nbrOfDecks = ['2', '3'];

export const models = {
  2: ['SS1012'],
  3: [
    'SS1223',
    'SS1233',
    'SS1433',
    'SS1823',
    'SS1833',
    'SS1013H',
    'SS1233H',
    'SS1633H',
  ],
};

export const screeningElements = {
  1: [
    { name: 'Wire, square holes', value: 'WIRE_SQUARE' },
    { name: 'Wire, rect. holes', value: 'WIRE_RECT' },
    { name: 'Plate', value: 'PLATE' },
    { name: 'Rubber', value: 'RUBBER' },
  ],
  2: [
    { name: 'Wire, square holes', value: 'WIRE_SQUARE' },
    { name: 'Wire, rect. holes', value: 'WIRE_RECT' },
  ],
  3: [
    { name: 'Wire, square holes', value: 'WIRE_SQUARE' },
    { name: 'Wire, rect. holes', value: 'WIRE_RECT' },
  ],
};

export const materials = [
  { name: 'Blasted or jaw crushed', value: 'BLASTED_OR_JAW_CRUSHED' },
  { name: 'Normal crushed stone', value: 'NORMAL_CRUSHED_STONE' },
  { name: 'Mix, 50% nat. / 50% crushed', value: 'MIXED_NATURAL_CRUSHED' },
  { name: 'Cubical crushed (VSI/HSI)', value: 'CUBICAL_CRUSHED' },
  { name: 'Uncrushed sand and gravel', value: 'UNCRUSHED_SAND_AND_GRAVEL' },
];

export const getDefaultData = (): UnitInfoFreeFallScreenSSInterface => {
  return {
    modelName: models[2][0],
    nbrOfDecks: 2,
    deckList: {
      0: {
        separationSize: 25,
        screeningMediaId: screeningElements[1][0],
        display: { separationSize: true, screeningElement: false },
      },
      1: {
        separationSize: 16,
        screeningMediaId: screeningElements[2][0],
        display: { separationSize: true, screeningElement: false },
      },
      2: {
        separationSize: 8,
        screeningMediaId: screeningElements[3][0],
        display: { separationSize: true, screeningElement: false },
      },
    },
    deckOneRelieving: false,
    deckTwoRelieving: false,
    materialType: materials[0],
    moisture: 0,
    newMoisture: false,
    parallelUnits: 1,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayLoad: true,
      displayNumberOfDecks: false,
    },
  };
};

export const getHorsePower = (kW: number) => {
  return (kW * 1.3596216173).toFixed(2);
};

export class FreeFallScreenSSConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoFreeFallScreenSSInterface {
    return {
      modelName: models[2][0],
      nbrOfDecks: 2,
      deckList: {
        0: {
          separationSize: 25,
          screeningMediaId: screeningElements[1][0],
          display: { separationSize: true, screeningElement: false },
        },
        1: {
          separationSize: 16,
          screeningMediaId: screeningElements[2][0],
          display: { separationSize: true, screeningElement: false },
        },
        2: {
          separationSize: 8,
          screeningMediaId: screeningElements[3][0],
          display: { separationSize: true, screeningElement: false },
        },
      },
      deckOneRelieving: false,
      deckTwoRelieving: false,
      materialType: materials[0],
      ...BaseUnitConfig.getBaseDefaults(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayNumberOfDecks: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 4;
  }
}

export const freeFallScreenSSConfig = new FreeFallScreenSSConfig();
